import Input from 'src/components/Input/Input';
import { Controller } from 'react-hook-form';
import React, { useEffect } from 'react';
import { clsx } from 'clsx';

const EmptyListItem = ({ readonly }) => {
  return (
    <div className={'bg-white border border-[#E3E6E8] rounded-sm-5'}>
      <div
        className={clsx(
          'flex flex-row py-1 px-1.5 gap-2 items-center ',
          readonly && 'pointer-events-none opacity-50',
        )}
      >
        <div className={'text-ebony_opacity_80 text-xs font-medium capitalize'}>
          without restrictions
        </div>
      </div>
    </div>
  );
};
const BlackListItem = ({ word, onDelete = (() => {}) as (word?: any) => void, readonly }) => {
  return (
    <div className={'bg-white border border-[#a498ff80] rounded-sm-5'}>
      <div
        className={clsx(
          'flex flex-row py-1 px-1.5 gap-2 items-center bg-[#a498ff1a] w-full h-full',
          readonly && 'pointer-events-none opacity-50',
        )}
      >
        <div className={'text-ebony_opacity_80 text-xs font-medium'}>{word}</div>
        {!readonly && (
          <div className={'group'}>
            <svg
              height="14"
              width="14"
              viewBox="0 0 20 20"
              focusable="false"
              className="cursor-pointer group-hover:fill-[#de350b]"
              onClick={() => onDelete(word)}
            >
              <path d="M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"></path>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export const WordsBlackListField = ({
  field,
  data,
  control,
  readonly,
  compact,
  watch = (() => {}) as (key?: any) => any,
  setValue,
}) => {
  const fieldValue = watch(field.key);
  const [blackList, setBlackList] = React.useState([]);

  const deleteWord = (word) => {
    const newBlackList = blackList.filter((item) => item !== word);

    setBlackList(newBlackList);
  };

  const addToBlackList = (word) => {
    const isExist = blackList.some(
      (listItem) => listItem.trim().toLowerCase() === word.trim().toLowerCase(),
    );

    if (!isExist) {
      const newBlackList = [...blackList, word.trim()].filter(Boolean);

      setBlackList(newBlackList);
    }
  };

  const onValueChange = (e, onChange) => {
    if (e.target.value.includes(' ')) {
      addToBlackList(e.target.value);
      return onChange('');
    }

    onChange(e.target.value);
  };

  const onKeyDownHandler = (e, onChange) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      addToBlackList(e.target.value);
      return onChange('');
    }
  };

  useEffect(() => {
    setValue('pf_words_blacklist', blackList);
  }, [blackList]);

  useEffect(() => {
    if (readonly) {
      setBlackList(data || []);
      return;
    }

    if (!fieldValue) {
      setBlackList(data || []);
    } else {
      setBlackList(fieldValue);
    }
  }, [field, data, readonly]);

  return field ? (
    <div className={'flex flex-col gap-[5px] w-full'}>
      <div>
        <p className={'text-ebony_opacity_30 text-xs font-medium'}>Word blacklist</p>
      </div>
      <div className={'flex flex-row gap-[5px] w-full flex-wrap'}>
        {blackList.length ? (
          blackList.map((word) => {
            return (
              <BlackListItem word={word} key={word} onDelete={deleteWord} readonly={readonly} />
            );
          })
        ) : readonly ? (
          <EmptyListItem readonly={readonly} />
        ) : null}
      </div>
      {!readonly && (
        <div>
          <Controller
            control={control}
            name={'pf_words_blacklist_item'}
            render={({ field: { onChange, value }, fieldState: { error } }) => (
              <div className={'flex flex-col w-full'}>
                <Input
                  className={'!py-2.5 !text-sm placeholder:text-sm'}
                  readonly={readonly}
                  type={'text'}
                  placeholder={'Add words AI shouldn’t use in answers'}
                  invalidMessage={error?.message}
                  value={value || ''}
                  isValid={!error?.message}
                  onChange={(e) => onValueChange(e, onChange)}
                  onKeyDown={(e) => onKeyDownHandler(e, onChange)}
                />
              </div>
            )}
          />
        </div>
      )}
    </div>
  ) : null;
};
